var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"reference"},[_vm._t("default"),_vm._v(" "),(_setup.show)?_c(_setup.Panel,{ref:"floatingPanel",attrs:{"styles":_setup.floatingStyles,"collections":_setup.collections,"marker":_setup.marker},on:{"refresh":_setup.fetchData}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }